import {
  GET_CUSTOMER_DETAILS_REQUEST,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_DETAILS_FAILURE,
  GET_CLIENT_LIST_REQUEST,
  GET_CLIENT_LIST_SUCCESS,
  GET_CLIENT_LIST_FAILURE,
  UPDATE_CUSTOMER_DETAILS_REQUEST,
  UPDATE_CUSTOMER_DETAILS_SUCCESS,
  UPDATE_CUSTOMER_DETAILS_FAILURE,
  CREATE_CLIENT_REQUEST,
  CREATE_CLIENT_SUCCESS,
  CREATE_CLIENT_FAILURE,
  GET_FAX_TEMPLATES_REQUEST,
  GET_FAX_TEMPLATES_SUCCESS,
  GET_FAX_TEMPLATES_FAILURE,
} from './CustomerView.actions';
import {
  GET_SENSITIVE_FIELDS_REQUEST,
  GET_SENSITIVE_FIELDS_SUCCESS,
  GET_SENSITIVE_FIELDS_FAILURE,
} from '../ClientView/ClientView.actions';
import { DEFAULT_PAGE_SIZE } from "../CustomerList/Customer.reducer";

const initialState = {
  details: null,
  clients: [],
  loadingDetails: false,
  loadingClients: false,
  error: null,
  clientListState: {
    page: 0,
    pageSize: DEFAULT_PAGE_SIZE,
    sorted: [{ id: "clientName", desc: false }],
    filtered: [],
  },
  pages: 0,
  totalElements: 0,
  updating: false,
  creatingClient: false,
  createClientError: null,
  faxTemplates: {},
  loadingFaxTemplates: false,
  getFaxTemplatesError: null,
  updateError: null,
  sensitiveFields: [],
};

export function Reducer(previousState = initialState, action) {
  switch (action.type) {
    case GET_SENSITIVE_FIELDS_REQUEST:
      return {
        ...previousState,
        loadingDetails: true,
        error: null,
      };
    case GET_SENSITIVE_FIELDS_SUCCESS:
      const rawValue = action.payload && typeof action.payload === 'object' && action.payload.propertyValue ? action.payload.propertyValue : action.payload;
      return {
        ...previousState,
        loadingDetails: false,
        sensitiveFields: typeof rawValue === 'string' ? rawValue.split(',').map(s => s.trim()) : [],
      };
    case GET_SENSITIVE_FIELDS_FAILURE:
      return {
        ...previousState,
        loadingDetails: false,
        error: action.payload,
      };
    case GET_CUSTOMER_DETAILS_REQUEST:
      return {
        ...previousState,
        loadingDetails: true,
        error: null,
      };
    case GET_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...previousState,
        loadingDetails: false,
        details: action.payload,
      };
    case GET_CUSTOMER_DETAILS_FAILURE:
      return {
        ...previousState,
        loadingDetails: false,
        error: action.payload,
      };
    case GET_CLIENT_LIST_REQUEST:
      return {
        ...previousState,
        loadingClients: true,
        clientListState: action.payload.listState,
      };
    case GET_CLIENT_LIST_SUCCESS:
      return {
        ...previousState,
        loadingClients: false,
        clients: action.payload.records,
        pages: action.payload.totalPages,
        totalElements: action.payload.totalElements,
      };
    case GET_CLIENT_LIST_FAILURE:
      return {
        ...previousState,
        loadingClients: false,
        error: action.payload,
      };
    case UPDATE_CUSTOMER_DETAILS_REQUEST:
      return {
        ...previousState,
        updating: true,
        updateError: null,
      };
    case UPDATE_CUSTOMER_DETAILS_SUCCESS:
      return {
        ...previousState,
        updating: false,
        details: action.payload,
      };
    case UPDATE_CUSTOMER_DETAILS_FAILURE:
      return {
        ...previousState,
        updating: false,
        updateError: action.payload,
      };
    case CREATE_CLIENT_REQUEST:
      return {
        ...previousState,
        creatingClient: true,
        createClientError: null,
      };
    case CREATE_CLIENT_SUCCESS:
      return {
        ...previousState,
        creatingClient: false,
      };
    case CREATE_CLIENT_FAILURE:
      return {
        ...previousState,
        creatingClient: false,
        createClientError: action.payload,
      };
    case GET_FAX_TEMPLATES_REQUEST:
      return {
        ...previousState,
        loadingFaxTemplates: true,
        getFaxTemplatesError: null,
      };
    case GET_FAX_TEMPLATES_SUCCESS:
      return {
        ...previousState,
        loadingFaxTemplates: false,
        faxTemplates: action.payload,
      };
    case GET_FAX_TEMPLATES_FAILURE:
      return {
        ...previousState,
        loadingFaxTemplates: false,
        getFaxTemplatesError: action.payload,
      };
    default:
      return previousState;
  }
}
